<div class="suggestlist-container" [ngClass]="{'suggestListLoading': isLoading}">
  <span *ngIf="dropDownVariant === dropDownVariants.ComboBox" class="combobox-wrapper">
    <kendo-multiselect
      class="w-100 variant-combobox"
      [readonly]="readonly"
      [class.readonly]="readonly"
      [itemDisabled]="itemDisabled"
      [allowCustom]="allowCustom"
      [valueNormalizer]="valueNormalizer"
      textField="{{ textField }}"
      [valueField]="valueField"
      [valuePrimitive]="valuePrimitive"
      [data]="data"
      [ngModel]="value ? [value] : []"
      [placeholder]="!isFocused && placeholder ? placeholder : ''"
      [disabled]="disabled"
      [required]="required"
      [filterable]="filterable"
      (filterChange)="onFilterChange($event)"
      (ngModelChange)="comboboxValueChanged($event)"
      (blur)="onTouch()"
      (focus)="onFocus()"
      (open)="dropdownAboutToOpen($event)"
      (close)="onClose($event)"
      (change)="handleComboBoxChangeEvent($event)"
      [popupSettings]="popupSettings"
      [virtual]="virtualizationSettings"
      [class.ng-invalid]="asFormControl?.invalid"
      (keydown.arrowup)="handleComboBoxKeyEvent($event)"
      (keydown.arrowdown)="handleComboBoxKeyEvent($event)"
      (keydown.enter)="handleComboBoxEnterEvent()"
      (keydown.backspace)="handleComboBoxBackspaceEvent()"
      #kendoComboBox
    >
      <ng-template kendoMultiSelectItemTemplate let-dataItem>
        <div *ngIf="!dataItem.customValue" class="popup-item-wrapper"
             [ngStyle]="{'max-width': popupSettings?.width === 'auto' ? maxPopupWidthPxSignal() : null}">
          <ng-container *ngIf="detailTemplate">
            <ng-container *ngTemplateOutlet="detailTemplate; context: { $implicit: dataItem }"> </ng-container>
          </ng-container>
          <ng-container *ngIf="!detailTemplate && valuePrimitive">
            {{ dataItem[textField] }}
          </ng-container>
          <ng-container *ngIf="!detailTemplate && !valuePrimitive">
            {{ dataItem }}
          </ng-container>
        </div>
        <div *ngIf="dataItem.customValue && dataContainsSingleCustomValue" class="popup-item-wrapper spacer-looking-like-empty-list">
        </div>
      </ng-template>
      <ng-template kendoMultiSelectTagTemplate let-dataItem>
        <div [ngbTooltip]="valuePrimitive ? dataItem[textField] : dataItem" container="body" trigger="hover"
             qpointShowIfTruncated>
          <ng-container *ngIf="valueTemplate">
            <ng-container *ngTemplateOutlet="valueTemplate; context: { $implicit: dataItem }"> </ng-container>
          </ng-container>
          <ng-container *ngIf="!valueTemplate && valuePrimitive && !isString(dataItem)">
            {{ dataItem[textField] }}
          </ng-container>
          <ng-container *ngIf="!valueTemplate && (!valuePrimitive || isString(dataItem))">
            {{ dataItem }}
          </ng-container>
        </div>
      </ng-template>
      <ng-template kendoMultiSelectGroupTemplate let-dataItem *ngIf="groupTemplate">
        <ng-container *ngTemplateOutlet="groupTemplate; context: { $implicit: dataItem }"> </ng-container>
      </ng-template>
      <ng-template kendoMultiSelectFixedGroupTemplate let-dataItem *ngIf="groupTemplate">
        <ng-container *ngTemplateOutlet="groupTemplate; context: { $implicit: dataItem }"> </ng-container>
      </ng-template>
      <ng-template *ngIf="hasMoreEntries" kendoMultiSelectFooterTemplate>
        <a class="combobox-footer" [routerLink]=""
           (click)="footerClick()">{{ 'common.showMoreEntries' | translate }}</a>
      </ng-template>

      <ng-template kendoMultiSelectNoDataTemplate>
        <ng-container *ngTemplateOutlet="noDataTemplate"></ng-container>
        <div *ngIf="!noDataTemplate">
        </div>
    </ng-template>
    <kendo-multiselect-messages clearTitle=""></kendo-multiselect-messages>
    </kendo-multiselect>
    <button kendoButton class="kendo-button" *ngIf="!readonly" [disabled]="disabled" [svgIcon]="chevronDownIcon"
                  (click)="openMultiselectDropdown()" type="button"> </button>
  </span>

  <kendo-multiselect
    class="w-100 variant-multiselect"
    [readonly]="readonly"
    [class.readonly]="readonly"
    [itemDisabled]="itemDisabled"
    [allowCustom]="allowCustom"
    [valueNormalizer]="valueNormalizer"
    textField="{{ textField }}"
    valueField="{{ valueField }}"
    [valuePrimitive]="valuePrimitive"
    [data]="data"
    [(ngModel)]="value"
    [placeholder]="!isFocused ? placeholder : ''"
    [disabled]="disabled || isLoading"
    [required]="required"
    [filterable]="filterable"
    (filterChange)="onFilterChange($event)"
    (ngModelChange)="valueChanged($event)"
    (blur)="onTouch()"
    (focus)="onFocus()"
    (open)="dropdownAboutToOpen($event)"
    (close)="onClose($event)"
    (change)="handleComboBoxChangeEvent($event)"
    #kendoMultiSelect
    [popupSettings]="popupSettings"
    [virtual]="virtualizationSettings"
    [class.ng-invalid]="asFormControl?.invalid"
    *ngIf="dropDownVariant === dropDownVariants.MultiSelect"
  >
    <ng-template kendoMultiSelectItemTemplate let-dataItem>
      <div class="popup-item-wrapper"
           [ngStyle]="{'max-width': popupSettings?.width === 'auto' ? maxPopupWidthPxSignal() : null}">
        <ng-container *ngIf="detailTemplate">
          <ng-container *ngTemplateOutlet="detailTemplate; context: { $implicit: dataItem }"></ng-container>
        </ng-container>
        <ng-container *ngIf="!detailTemplate && valuePrimitive">
          {{ dataItem[textField] }}
        </ng-container>
        <ng-container *ngIf="!detailTemplate && !valuePrimitive">
          {{ dataItem }}
        </ng-container>
      </div>
    </ng-template>
    <ng-template kendoMultiSelectTagTemplate let-dataItem>
      <div [ngbTooltip]="valuePrimitive ? dataItem[textField] : dataItem" container="body" trigger="hover"
           qpointShowIfTruncated>
        <ng-container *ngIf="valueTemplate">
          <ng-container *ngTemplateOutlet="valueTemplate; context: { $implicit: dataItem }"></ng-container>
        </ng-container>
        <ng-container *ngIf="!valueTemplate && valuePrimitive && !isString(dataItem)">
          {{ dataItem[textField] }}
        </ng-container>
        <ng-container *ngIf="!valueTemplate && (!valuePrimitive || isString(dataItem))">
          {{ dataItem }}
        </ng-container>
      </div>
    </ng-template>
    <ng-template *ngIf="hasMoreEntries" kendoMultiSelectFooterTemplate>
      <a class="combobox-footer" [routerLink]="" (click)="footerClick()">{{ 'common.showMoreEntries' | translate }}</a>
    </ng-template>

    <ng-template kendoDropDownListGroupTemplate let-dataItem *ngIf="groupTemplate">
      <ng-container *ngTemplateOutlet="groupTemplate; context: { $implicit: dataItem }"></ng-container>
    </ng-template>
    <ng-template kendoDropDownListFixedGroupTemplate let-dataItem *ngIf="groupTemplate">
      <ng-container *ngTemplateOutlet="groupTemplate; context: { $implicit: dataItem }"></ng-container>
    </ng-template>

    <ng-template kendoMultiSelectNoDataTemplate>
      <ng-container *ngTemplateOutlet="noDataTemplate"></ng-container>
      <div *ngIf="!noDataTemplate">
      </div>
    </ng-template>
    <kendo-multiselect-messages clearTitle=""></kendo-multiselect-messages>
  </kendo-multiselect>
  <kendo-dropdownlist
    class="w-100"
    [readonly]="readonly"
    [class.readonly]="readonly"
    [itemDisabled]="itemDisabled"
    [textField]="textField"
    [valueField]="valueField"
    [defaultItem]="dropdownDefaultItem"
    [valuePrimitive]="valuePrimitive"
    [data]="data"
    [(ngModel)]="value"
    [disabled]="disabled || isLoading"
    [required]="required"
    [filterable]="filterable"
    (filterChange)="onFilterChange($event)"
    (ngModelChange)="valueChanged($event)"
    (blur)="onTouch()"
    (focus)="onFocus()"
    [popupSettings]="popupSettings"
    (open)="dropdownAboutToOpen($event)"
    (close)="onClose($event)"
    (keydown.backspace)="resetValue($event)"
    [class.ng-invalid]="asFormControl?.invalid"
    #kendoDropdown
    *ngIf="dropDownVariant === dropDownVariants.DropDownList"
  >
    <ng-template kendoDropDownListItemTemplate let-dataItem>
      <div class="popup-item-wrapper"
           [ngStyle]="{'max-width': popupSettings?.width === 'auto' ? maxPopupWidthPxSignal() : null}">
        <ng-container *ngIf="detailTemplate">
          <ng-container *ngTemplateOutlet="detailTemplate; context: { $implicit: dataItem }"></ng-container>
        </ng-container>
        <ng-container *ngIf="!detailTemplate && valuePrimitive">
          {{ dataItem[textField] }}
        </ng-container>
        <ng-container *ngIf="!detailTemplate && !valuePrimitive">
          {{ dataItem }}
        </ng-container>
      </div>
    </ng-template>
    <ng-template kendoDropDownListValueTemplate let-dataItem>
      <div [ngbTooltip]="dataItem ? (valuePrimitive ? dataItem[textField] : dataItem) : null" container="body"
           trigger="hover" qpointShowIfTruncated>
        <div class="clearDropdownWrapper">
          <div class="d-flex flex-grow-1">
            <ng-container *ngTemplateOutlet="valueTemplate; context: { $implicit: dataItem }"></ng-container>
            <span *ngIf="!valueTemplate">{{ dataItem ? (valuePrimitive ? dataItem[textField] : dataItem) : '' }}</span>
          </div>
          <div *ngIf="clearButtonVisible" class="d-flex clearDropdownButton" (click)="resetValue($event)">
            <span class="k-icon k-i-close k-clear-value p-0"></span>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template kendoDropDownListNoDataTemplate>
      <ng-container *ngTemplateOutlet="noDataTemplate"></ng-container>
      <div *ngIf="!noDataTemplate">
      </div>
    </ng-template>
    <ng-template kendoDropDownListGroupTemplate let-dataItem *ngIf="groupTemplate">
      <ng-container *ngTemplateOutlet="groupTemplate; context: { $implicit: dataItem }"></ng-container>
    </ng-template>
    <ng-template kendoDropDownListFixedGroupTemplate let-dataItem *ngIf="groupTemplate">
      <ng-container *ngTemplateOutlet="groupTemplate; context: { $implicit: dataItem }"></ng-container>
    </ng-template>
  </kendo-dropdownlist>
  <qpoint-loading-indicator [class.multiselect]="dropDownVariant === dropDownVariants.MultiSelect"
                            [isLoading]="isLoading"></qpoint-loading-indicator>
</div>
